import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BasicEventPlayer} from "../../../entities/auth/BasicEventPlayer";
import {APIService} from "../../../services/APIService";
import {Role} from "../../../entities/auth/Role";

@Component({
  selector: 'app-role-dialogue',
  templateUrl: './role-dialogue.component.html',
  styleUrls: ['./role-dialogue.component.css']
})
export class RoleDialogueComponent {
  roleGroup;

  roleControl = new FormControl();

  roles: Role[] = []

  constructor(private _formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<RoleDialogueComponent>,
              private api: APIService,
              @Inject(MAT_DIALOG_DATA) public player: BasicEventPlayer) {
    this.roleControl = new FormControl(player.roles)

    this.roleGroup = _formBuilder.group({
      firstCtrl: [player.roles, Validators.required]
    })

    this.api.listRoles().then((r) => {
      this.roles = r.map(x => {
        return {
          ...x,
          id: parseInt(x.id.toString(), 10)
        }
      });
      console.log(r);
    });
  }

  save() {
    console.log(this.roleGroup.value.firstCtrl);
    this.dialogRef.close({roles: this.roleGroup.value.firstCtrl})
  }
}
